import React from 'react';
import { Link, withRouter } from 'react-router-dom';

const Page401 = (props) => {
    return (
          <div className='container '>
                    <div >
                    <div className=" vh-70 mt-5">
                    <h1 className="text-danger">401</h1>
                    <span style={{fontSize:20, fontFamily:"", fontWeight:500}}>There was some error or something went wrong, Please try again later.</span>
                    <hr />
                    <span style={{fontSize:20, fontFamily:"", fontWeight:500}}>Sorry for the inconvenience. <Link to="/Support"> Get back to our home page</Link>. </span>
                    <span style={{fontSize:20, fontFamily:"", fontWeight:500}}>If you require further immediate assistance, please <Link to="/Support"> contact our support to</Link> reach out to us. </span>
                </div>
                    </div>
                </div>
    )
}

export default Page401;